import AnchorLink from 'components/ui/AnchorLink';
import styled from 'styled-components';

export const StyledUl = styled.ul`
  list-style-type: disc;
`;

export const StyledAnchorLink = styled(AnchorLink)`
  font-style:italic;
`;
